
const GraphIcon = () => {
    return (
        <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M38.6193 15.7459C38.1696 11.8291 36.4086 8.17949 33.6225 5.39005C30.8364 2.60061 27.1889 0.835269 23.2726 0.380859L22.2471 1.29653V15.8374L23.1627 16.7531H37.7037L38.6193 15.7459Z" fill="#CCB0FF"/>
            <path d="M20.4154 18.5844V0.270874H19.4997C15.6965 0.270874 11.9787 1.39864 8.81653 3.51157C5.65431 5.6245 3.18966 8.62768 1.73425 12.1414C0.278839 15.655 -0.101962 19.5214 0.639999 23.2515C1.38196 26.9815 3.21336 30.4079 5.90261 33.0971C8.59185 35.7864 12.0182 37.6177 15.7483 38.3597C19.4783 39.1017 23.3447 38.7209 26.8584 37.2655C30.372 35.8101 33.3752 33.3454 35.4881 30.1832C37.6011 27.021 38.7288 23.3032 38.7288 19.5V18.5844H20.4154Z" fill="#9F7EDC"/>
        </svg>
    )
}

export default GraphIcon;

